import React from "react";
import Banner from "../../components/Banner";
import { Sidebar } from "../../components/Sidebar";
import axios from "axios";
import Spinner from "../../components/Spinner";
import UpdateProfile from "./updateProfile";

const API = localStorage.getItem("assethost");

export default class IndividualProfileView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // request state
      loading: true,
      msg: "",
      toastColor: "",
      showUpdate: false,

      // flattened profile (user-level)
      username: "",
      fullName: "",
      isPaidService: "",
      activeStatus: "",
      profileType: "",
      townName: "",

      // flattened individual profile
      firstName: "",
      surname: "",
      middleName: "",
      nationalIdNumber: "",
      cellPhone: "",
      gender: "",
      email: "",
      mobileMoneyNumber: "",
      nationality: "",
      houseNumberStreet: "",
      suburb: "",
    };
  }

  componentDidMount() {
    const params = new URLSearchParams(window.location.search);
    const userId =
      this.props.id || params.get("id") || sessionStorage.getItem("userId");
    this.loadProfile(userId);
  }

  safeText(v) {
    return v === null || v === undefined || v === "" ? "" : String(v);
  }

  loadProfile(userId) {
    const token = sessionStorage.getItem("token");
    if (!token || !userId) {
      this.setState({
        loading: false,
        msg: "No User Token",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.href = `/?redirectUrl=${
        window.location.pathname + window.location.search
      }`;
      return;
    }

    axios
      .get(API + `/users/${userId}/profile`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        const p = response.data || {};
        const i = p.individualProfile || {};
        const nationalityRaw = i.nationality;
        const nationalityStr =
          nationalityRaw && typeof nationalityRaw === "object"
            ? nationalityRaw.label || nationalityRaw.value || ""
            : nationalityRaw || "";

        this.setState({
          loading: false,
          msg: "",
          toastColor: "",

          username: this.safeText(p.username),
          fullName: this.safeText(p.fullName),
          isPaidService: this.safeText(p.isPaidService),
          activeStatus: this.safeText(p.activeStatus),
          profileType: this.safeText(p.profileType),
          townName: this.safeText(p.townName),

          firstName: this.safeText(i.firstName),
          surname: this.safeText(i.surname),
          middleName: this.safeText(i.middleName),
          nationalIdNumber: this.safeText(i.nationalIdNumber),
          cellPhone: this.safeText(i.cellPhone),
          gender: this.safeText(i.gender),
          email: this.safeText(i.email),
          mobileMoneyNumber: this.safeText(i.mobileMoneyNumber),
          nationality: this.safeText(nationalityStr),
          houseNumberStreet: this.safeText(i.houseNumberStreet),
          suburb: this.safeText(i.suburb),
        });
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        this.setState({
          loading: false,
          msg: error?.response?.data?.message || "Failed to load profile.",
          toastColor: "danger",
        });
      });
  }

  render() {
    const s = this.state;

    if (s.loading) {
      return <Spinner className="" />;
    }

    let divMsg = null;
    if (s.msg) {
      divMsg = (
        <div
          className={
            s.toastColor === "success"
              ? "alert alert-success mx-7"
              : "alert alert-danger mx-7"
          }
        >
          {s.msg}
        </div>
      );
    }

    return (
      <div className="min-vh-100 d-flex justify-content-between bg-white">
        <Sidebar />
        <div className="min-vh-100 flex-grow-1 d-flex flex-column">
          <Banner title={`Profile: ${s.fullName || "Individual"}`} />
          {divMsg}
          <div className="w-100 flex-grow-1 px-5 d-flex flex-column align-items-center justify-content-center">
            <div className="w-100 mt-8 h-100 overflow-y-auto" style={{ maxWidth: '48rem' }}>
              <div className="row g-4">
                <div className="d-flex flex-column gap-1 border-bottom pb-2">
                  <div className="fw-bold">Full Name</div>
                  <div>
                    {s.fullName || <span className="text-secondary">-</span>}
                  </div>
                </div>
                <div className="flex flex-col gap-1 border-b pb-2">
                  <div className="fw-bold">Is Paid Service?</div>
                  <div>
                    {s.isPaidService || (
                      <span className="text-secondary">-</span>
                    )}
                  </div>
                </div>
                <div className="flex flex-col gap-1 border-b pb-2">
                  <div className="fw-bold">Is Active?</div>
                  <div>
                    {s.activeStatus || <span className="text-secondary">-</span>}
                  </div>
                </div>
                <div className="flex flex-col gap-1 border-b pb-2">
                  <div className="fw-bold">Profile Type</div>
                  <div>
                    {s.profileType || <span className="text-secondary">-</span>}
                  </div>
                </div>
                <div className="flex flex-col gap-1 border-b pb-2">
                  <div className="fw-bold">Town/City</div>
                  <div>
                    {s.townName || <span className="text-secondary">-</span>}
                  </div>
                </div>
                <div className="flex flex-col gap-1 border-b pb-2">
                  <div className="fw-bold">Firstname</div>
                  <div>
                    {s.firstName || <span className="text-secondary">-</span>}
                  </div>
                </div>
                <div className="flex flex-col gap-1 border-b pb-2">
                  <div className="fw-bold">Surname</div>
                  <div>
                    {s.surname || <span className="text-secondary">-</span>}
                  </div>
                </div>
                <div className="flex flex-col gap-1 border-b pb-2">
                  <div className="fw-bold">Middle name</div>
                  <div>
                    {s.middleName || <span className="text-secondary">-</span>}
                  </div>
                </div>
                {!s.passportNumber && (
                  <div className="flex flex-col gap-1 border-b pb-2">
                    <div className="fw-bold">National ID</div>
                    <div>
                      {s.nationalIdNumber || (
                        <span className="text-gray-400">-</span>
                      )}
                    </div>
                  </div>
                )}
                {s.passportNumber && (
                  <div className="flex flex-col gap-1 border-b pb-2">
                    <div className="fw-bold">Passport Number</div>
                    <div>
                      {s.passportNumber || (
                        <span className="text-gray-400">-</span>
                      )}
                    </div>
                  </div>
                )}
                <div className="flex flex-col gap-1 border-b pb-2">
                  <div className="fw-bold">Cellphone</div>
                  <div>
                    {s.cellPhone || <span className="text-secondary">-</span>}
                  </div>
                </div>
                <div className="flex flex-col gap-1 border-b pb-2">
                  <div className="fw-bold">Gender</div>
                  <div>
                    {s.gender || <span className="text-secondary">-</span>}
                  </div>
                </div>
                <div className="flex flex-col gap-1 border-b pb-2">
                  <div className="fw-bold">Email</div>
                  <div>
                    {s.email || <span className="text-secondary">-</span>}
                  </div>
                </div>
                <div className="flex flex-col gap-1 border-b pb-2">
                  <div className="fw-bold">Mobile Money Number</div>
                  <div>
                    {s.mobileMoneyNumber || (
                      <span className="text-secondary">-</span>
                    )}
                  </div>
                </div>
                <div className="flex flex-col gap-1 border-b pb-2">
                  <div className="fw-bold">Nationality</div>
                  <div>
                    {s.nationality || <span className="text-secondary">-</span>}
                  </div>
                </div>
                <div className="flex flex-col gap-1 border-b pb-2">
                  <div className="fw-bold">House Number Street</div>
                  <div>
                    {s.houseNumberStreet || (
                      <span className="text-secondary">-</span>
                    )}
                  </div>
                </div>
                <div className="flex flex-col gap-1 border-b pb-2">
                  <div className="fw-bold">Suburb</div>
                  <div>
                    {s.suburb || <span className="text-secondary">-</span>}
                  </div>
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-center gap-8 mt-2">
              <button
                type="button"
                name="update"
                className="btn btn-primary"
                onClick={() => this.setState({ showUpdate: true })}
              >
                Update Profile
              </button>
              <button
                type="button"
                name="cancel"
                className="btn btn-primary"
                onClick={() => window.history.back()}
              >
                Cancel
              </button>
            </div>
          </div>
          
        </div>
        {s.showUpdate && (
          <div className="position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-50 d-flex align-items-start justify-content-center" style={{ zIndex: 50 }}>
            <div className="bg-white rounded-bottom w-100 h-5-6 overflow-scroll d-flex flex-column px-7">
              <Banner
                key={`poll-message-banner`}
                title="Update user"
                withIcons={false}
              />
              <div className="d-flex flex-column align-items-center justify-content-center flex-grow-1">
                <UpdateProfile
                  onClose={() => this.setState({ showUpdate: false })}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}
